import { gql } from "@/apis/nannyml";

export const sendTestWebhookCall = gql(/* GraphQL */ `
  query SendTestWebhookCall($webhookSettings: WebhookNotificationSettingsInput!) {
    send_test_webhook_call(settings: $webhookSettings)
  }
`);
